module.exports = __webpack_public_path__ + "img/webSelect_0_0.c3f7f25f.png";